export default function Home7() {
    return (
      <div className="min-h-screen bg-white">
        <div className="max-w-7xl mx-auto px-6 py-12">
          {/* Main Heading */}
          <h1 
            className="mb-8 text-center leading-tight"
            style={{
              fontFamily: '"Futura Bold", Sans-serif',
              fontSize: '100px',
              fontWeight: 700,
              lineHeight: '100px',
              color: '#0A476C'
            }}
          >
            Uber Sexual Assault Lawsuit FAQs
          </h1>
  
          {/* Introduction */}
          <div className="mb-12 leading-relaxed">
            <p 
              className="mb-4"
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              Individuals who have experienced rideshare sexual assault often have a lot of pressing and questions. It is
              only getting experience that makes anyone offer expert advice in this regard. We hope this page has helped
              you understand why you need it, answer to get help the same way that we have helped many others. If you have
              been sexually assaulted by an Uber driver, you may be entitled to compensation.
            </p>
            <p 
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              Below are some additional questions and answers that we have experienced rideshare sexual assault often
              have. If you have specific questions related to your experience or are seeking to connect with an Uber
              sexual assault lawyer who can help you, reach out to us at anytime during the day or night.
            </p>
          </div>
  
          {/* FAQ Sections */}
          <div className="space-y-12">
            {/* Question 1 */}
            <section>
              <h2 
                className="mb-4 leading-tight"
                style={{
                  fontFamily: '"Futura Bold", Sans-serif',
                  fontSize: '25px',
                  fontWeight: 700,
                  lineHeight: '25px',
                  color: '#0A476C'
                }}
              >
                What is the difference between class action lawsuits and multi-district litigation?
              </h2>
              <div className="leading-relaxed space-y-4">
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Class action and multi-district litigation are both ways to handle cases when multiple lawsuits involve
                  similar issues and have cases against the same defendant.
                </p>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Class action lawsuits involve one single lawsuit brought on behalf of a large group of plaintiffs.
                </p>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  MDLs involve many individual lawsuits consolidated in the same court for pretrial proceedings. Once
                  pretrial proceedings are complete, the individual cases are sent back to their original courts for
                  trial, unless they are settled before trial. Because MDLs are multiple trials, they can take longer to
                  resolve than class actions.
                </p>
              </div>
            </section>
  
            {/* Question 2 */}
            <section>
              <h2 
                className="mb-4 leading-tight"
                style={{
                  fontFamily: '"Futura Bold", Sans-serif',
                  fontSize: '25px',
                  fontWeight: 700,
                  lineHeight: '25px',
                  color: '#0A476C'
                }}
              >
                How many sexual assault cases is Uber facing?
              </h2>
              <div className="leading-relaxed space-y-4">
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  In their first U.S. Safety Report, Uber reported over 10,000 sexual assaults, kidnappings, and deaths
                  between 2017 and 2018. Thousands of survivors have come forward to seek justice from Uber for sexual
                  assault and filing a claim against Uber.
                </p>
              </div>
            </section>
  
            {/* Question 3 */}
            <section>
              <h2 
                className="mb-4 leading-tight"
                style={{
                  fontFamily: '"Futura Bold", Sans-serif',
                  fontSize: '25px',
                  fontWeight: 700,
                  lineHeight: '25px',
                  color: '#0A476C'
                }}
              >
                Does Uber mandate mediation for sexual assault claims?
              </h2>
              <div className="leading-relaxed space-y-4">
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Before 2018, Uber required customers to pursue sexual assault claims through independent arbitration and
                  mediation rather than in court. This practice was criticized for keeping sexual assault cases out of the
                  public eye by requiring them to be handled in private arbitration proceedings.
                </p>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Uber finally ended required mediation and arbitration in 2018 after immense pressure from sexual assault
                  survivors and open letter campaigns by 14 states of sexual assault.
                </p>
              </div>
            </section>
  
            {/* Question 4 */}
            <section>
              <h2 
                className="mb-4 leading-tight"
                style={{
                  fontFamily: '"Futura Bold", Sans-serif',
                  fontSize: '25px',
                  fontWeight: 700,
                  lineHeight: '25px',
                  color: '#0A476C'
                }}
              >
                What safety measures has Uber implemented in response to sexual assault cases?
              </h2>
              <div className="leading-relaxed space-y-4">
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  In response to thousands of sexual assault cases against Uber and its drivers, the company has
                  implemented several new safety measures, including requiring drivers to take selfies to verify their
                  identity, adding an emergency button that connects riders to 911, and implementing and developed a
                  Women's Safety Forum to inform female users of additional safety features, which include:
                </p>
                <ul className="list-disc ml-6 space-y-2">
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    Mediation: You can attempt to reach a settlement with arbitration
                  </li>
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    Arbitration: You can resolve the claim with a final arbitrator
                  </li>
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    Litigation: You can choose legal or financial assistance by
                  </li>
                </ul>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  An experienced sexual assault lawyer can help you understand and evaluate your case and help you
                  understand your best course of action.
                </p>
              </div>
            </section>
  
            {/* Question 5 */}
            <section>
              <h2 
                className="mb-4 leading-tight"
                style={{
                  fontFamily: '"Futura Bold", Sans-serif',
                  fontSize: '25px',
                  fontWeight: 700,
                  lineHeight: '25px',
                  color: '#0A476C'
                }}
              >
                Will my privacy be protected if I file an Uber sexual assault lawsuit?
              </h2>
              <div className="leading-relaxed space-y-4">
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  In response to thousands of sexual assault cases against Uber and its drivers, the company has
                  implemented several new safety measures, including requiring drivers to take selfies to verify their
                  identity, adding an emergency button that connects riders to 911, and implementing and developed a
                  Women's Safety Forum to inform female users of additional safety features, which include:
                </p>
                <ul className="list-disc ml-6 space-y-2">
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    Put you ride and share my trip
                  </li>
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    Get help with a GPS-based location
                  </li>
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    24/7 phone safety support
                  </li>
                  <li 
                    style={{
                      fontSize: '21px',
                      lineHeight: '35px',
                      fontFamily: '"Avenir Book", sans-serif',
                      fontWeight: 400,
                      color: '#0A476C'
                    }}
                  >
                    In-app Emergency Button
                  </li>
                </ul>
              </div>
            </section>
          </div>
  
          {/* YouTube Video Section */}
          <div className="mt-16">
            <div className="relative w-full max-w-2xl mx-auto">
              <div className="relative aspect-video bg-gray-900 rounded-lg overflow-hidden">
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                  title="Random Video 1"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>

          {/* Additional Dummy Video Section */}
          
          {/* Uber Lawsuit Section */}
          <div className="mt-16">
            <div className="max-w-6xl mx-auto px-4">
              {/* Top Section - Informational Text */}
              <div className="mb-12">
                <h2 
                  className="mb-6 text-4xl font-bold text-gray-800 border-b-2 border-gray-800 pb-2"
                  style={{
                    fontFamily: '"Futura Bold", Sans-serif',
                    color: '#0A476C'
                  }}
                >
                  How long does an Uber lawsuit take?
                </h2>
                
                <div className="space-y-4 text-lg leading-relaxed" style={{ color: '#0A476C' }}>
                  <p style={{ fontFamily: '"Avenir Book", sans-serif' }}>
                    For lawsuits against Uber, the length of the legal process can differ greatly, from several months to years, depending on the facts and circumstances surrounding the case.
                  </p>
                  <p style={{ fontFamily: '"Avenir Book", sans-serif' }}>
                    In simpler cases where responsibility is clear, settlements can often be achieved relatively quickly, sometimes within a few months.
                  </p>
                  <p style={{ fontFamily: '"Avenir Book", sans-serif' }}>
                    However, in more complicated cases involving contested liability, severe injuries, or prolonged negotiations, the settlement timeline can be extended, requiring more time to reach a resolution.
                  </p>
                  <p style={{ fontFamily: '"Avenir Book", sans-serif' }}>
                    Not every Uber sexual assault lawsuit will be settled—some may go to trial depending on various factors, including Uber and the lawyer's actions. Additionally, given the ongoing disputes with the Uber Multi-District Litigation, cases may take longer to resolve.
                  </p>
                </div>
              </div>

              {/* Bottom Section - Call to Action and Image */}
              <div className="relative border-l-4 border-blue-300 border-b-4 border-blue-300 pb-8 pl-8">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  {/* Left Column - Call to Action */}
                  <div>
                    <h3 className="text-xl font-semibold mb-4" style={{ color: '#0A476C' }}>
                      Have you experienced sexual assault in an Uber or Lyft?
                    </h3>
                    <p className="text-2xl font-bold mb-6" style={{ color: '#0A476C' }}>
                      We can connect you to a rideshare abuse law firm today.
                      <span className="block w-full h-1 bg-yellow-400 mt-2"></span>
                    </p>
                    <button className="bg-yellow-400 text-gray-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-500 transition-colors">
                      Get the Help and Healing You Deserve
                    </button>
                  </div>

                  {/* Right Column - Image */}
                  <div className="relative">
                    <img 
                      src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                      alt="Lady Justice Statue"
                      className="w-full h-80 object-cover rounded-lg"
                    />
                    {/* Overlay Logo */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                      <div className="bg-yellow-400 rounded-full p-4 border-4 border-gray-800 relative">
                        <div className="text-center">
                          <div className="text-gray-800 font-bold text-sm">HELPING SURVIVORS</div>
                          <div className="text-gray-800 font-bold text-2xl">H</div>
                          <div className="text-gray-800 font-bold text-xs">HELPING SURVIVORS</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
  